import { useEffect, useState } from "react"
import "./SelectIcon.css"

export default function SelectIcon({ navItem, name = "", setIconFunc }) {
  const icons = [
    "add-circle-outline",
    "add-circle",
    "add",
    "airplane",
    "alarm",
    "albums",
    "alert",
    "american-football",
    "analytics",
    "aperture",
    "apps",
    "appstore",
    "archive",
    "arrow-back",
    "arrow-down",
    "arrow-dropdown-circle",
    "arrow-dropdown",
    "arrow-dropleft-circle",
    "arrow-dropleft",
    "arrow-dropright-circle",
    "arrow-dropright",
    "arrow-dropup-circle",
    "arrow-dropup",
    "arrow-forward",
    "arrow-round-back",
    "arrow-round-down",
    "arrow-round-forward",
    "arrow-round-up",
    "arrow-up",
    "at",
    "attach",
    "backspace",
    "barcode",
    "baseball",
    "basket",
    "basketball",
    "battery-charging",
    "battery-dead",
    "battery-full",
    "beaker",
    "bed",
    "beer",
    "bicycle",
    "bluetooth",
    "boat",
    "body",
    "bonfire",
    "book",
    "bookmark",
    "bookmarks",
    "bowtie",
    "briefcase",
    "browsers",
    "brush",
    "bug",
    "build",
    "bulb",
    "bus",
    "business",
    "cafe",
    "calculator",
    "calendar",
    "call",
    "camera",
    "car",
    "card",
    "cart",
    "cash",
    "cellular",
    "chatboxes",
    "chatbubbles",
    "checkbox-outline",
    "checkbox",
    "checkmark-circle-outline",
    "checkmark-circle",
    "checkmark",
    "clipboard",
    "clock",
    "close-circle-outline",
    "close-circle",
    "close",
    "cloud-circle",
    "cloud-done",
    "cloud-download",
    "cloud-outline",
    "cloud-upload",
    "cloud",
    "cloudy-night",
    "cloudy",
    "code-download",
    "code-working",
    "code",
    "cog",
    "color-fill",
    "color-filter",
    "color-palette",
    "color-wand",
    "compass",
    "construct",
    "contact",
    "contacts",
    "contract",
    "contrast",
    "copy",
    "create",
    "crop",
    "cube",
    "cut",
    "desktop",
    "disc",
    "document",
    "done-all",
    "download",
    "easel",
    "egg",
    "exit",
    "expand",
    "eye-off",
    "eye",
    "fastforward",
    "female",
    "filing",
    "film",
    "finger-print",
    "fitness",
    "flag",
    "flame",
    "flash-off",
    "flash",
    "flashlight",
    "flask",
    "flower",
    "folder-open",
    "folder",
    "football",
    "funnel",
    "gift",
    "git-branch",
    "git-commit",
    "git-compare",
    "git-merge",
    "git-network",
    "git-pull-request",
    "glasses",
    "globe",
    "grid",
    "hammer",
    "hand",
    "happy",
    "headset",
    "heart",
    "heart-dislike",
    "heart-empty",
    "heart-half",
    "help-buoy",
    "help-circle-outline",
    "help-circle",
    "help",
    "home",
    "hourglass",
    "ice-cream",
    "image",
    "images",
    "infinite",
    "information-circle-outline",
    "information-circle",
    "information",
    "jet",
    "journal",
    "key",
    "keypad",
    "laptop",
    "leaf",
    "link",
    "list-box",
    "list",
    "locate",
    "lock",
    "log-in",
    "log-out",
    "magnet",
    "mail-open",
    "mail-unread",
    "mail",
    "male",
    "man",
    "map",
    "medal",
    "medical",
    "medkit",
    "megaphone",
    "menu",
    "mic-off",
    "mic",
    "microphone",
    "moon",
    "more",
    "move",
    "musical-note",
    "musical-notes",
    "navigate",
    "notifications-off",
    "notifications-outline",
    "notifications",
    "nuclear",
    "nutrition",
    "open",
    "options",
    "outlet",
    "paper-plane",
    "paper",
    "partly-sunny",
    "pause",
    "paw",
    "people",
    "person-add",
    "person",
    "phone-landscape",
    "phone-portrait",
    "photos",
    "pie",
    "pin",
    "pint",
    "pizza",
    "planet",
    "play-circle",
    "play",
    "podium",
    "power",
    "pricetag",
    "pricetags",
    "print",
    "pulse",
    "qr-scanner",
    "quote",
    "radio-button-off",
    "radio-button-on",
    "radio",
    "rainy",
    "recording",
    "redo",
    "refresh-circle",
    "refresh",
    "remove-circle-outline",
    "remove-circle",
    "remove",
    "reorder",
    "repeat",
    "resize",
    "restaurant",
    "return-left",
    "return-right",
    "reverse-camera",
    "rewind",
    "ribbon",
    "rocket",
    "rose",
    "sad",
    "save",
    "school",
    "search",
    "send",
    "settings",
    "share-alt",
    "share",
    "shirt",
    "shuffle",
    "skip-backward",
    "skip-forward",
    "snow",
    "speedometer",
    "square-outline",
    "square",
    "star-half",
    "star-outline",
    "star",
    "stats",
    "stopwatch",
    "subway",
    "sunny",
    "swap",
    "switch",
    "sync",
    "tablet-landscape",
    "tablet-portrait",
    "tennisball",
    "text",
    "thermometer",
    "thumbs-down",
    "thumbs-up",
    "thunderstorm",
    "time",
    "timer",
    "today",
    "train",
    "transgender",
    "trash",
    "trending-down",
    "trending-up",
    "trophy",
    "tv",
    "umbrella",
    "undo",
    "unlock",
    "videocam",
    "volume-high",
    "volume-low",
    "volume-mute",
    "volume-off",
    "wallet",
    "walk",
    "warning",
    "watch",
    "water",
    "wifi",
    "wine",
    "woman",
  ]

  const [iconsList, setIconsList] = useState(icons)
  const [iconSearchInput, setIconSearchInput] = useState(null)
  const [selectedIcon, setSelectedIcon] = useState(null)

  function handleSearch(keyword) {
    setIconsList(() => {
      if (keyword.length) {
        return icons.filter((icon) => icon.includes(keyword))
      } else {
        return icons
      }
    })
  }

  useEffect(() => {
    if (name.length) {
      handleSearch(name)
      setSelectedIcon(name)
    }
  }, [])

  return (
    <div className="container-fluid selection-container p-3 rounded">
      {/* Search */}
      <input
        className="p-3 border-bottom mb-3"
        placeholder="Search to filter..."
        value={iconSearchInput || name}
        onChange={(e) => {
          setIconSearchInput(e.target.value)
          handleSearch(e.target.value)
        }}
      />
      <div className="container">
        <div className="row">
          {iconsList.map((icon, index) => (
            <div
              key={index}
              className={`rounded p-1 m-1 col d-flex align-items-center justify-content-center select-icon-container ${
                selectedIcon === icon && "selected-icon-container"
              }`}
              role={"button"}
              onClick={() => {
                if (selectedIcon !== icon) {
                  setIconFunc(navItem, icon)
                  setSelectedIcon(icon)
                  setIconSearchInput(icon)
                } else {
                  setIconFunc(navItem, null)
                  setSelectedIcon(null)
                  setIconSearchInput(null)
                }
              }}>
              <ion-icon name={icon}></ion-icon>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
